'use client';

import {VisuallyHidden, Root} from '@radix-ui/react-visually-hidden';

const VisuallyHiddenRoot = Root;
const VisuallyHiddenWrapper = VisuallyHidden;

export {VisuallyHiddenRoot, VisuallyHiddenWrapper};
